import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-comprovante-despesa',
  templateUrl: './modal-comprovante-despesa.component.html',
  styleUrls: ['./modal-comprovante-despesa.component.scss']
})
export class ModalComprovanteDespesaComponent implements OnInit {

  @Input() content: any;
  @ViewChild("card", null)
  private card: ElementRef;
  public listaComprovante = [];
  public comprovanteDefault;

  constructor(protected ref: NbDialogRef<ModalComprovanteDespesaComponent>) { }

  ngOnInit(): void {
    this.card.nativeElement.ownerDocument.activeElement.blur();
    this.content = this.content || [];
    this.getComprovanteJustificativa();
  }

  getComprovanteJustificativa() {
    this.listaComprovante = this.content.map(data => {
      return {
        message: data.message,
        filename: data.filename,
        file: data.file,
        selected: false,
      };
    });

    this.listaComprovante[0].selected = true;
    this.comprovanteDefault = this.listaComprovante[0];
  }

  getImagem(row) {
    if (row.file !== '') {
      return 'data:image/png;base64,' + row.file;
    }
    return 'none';
  }

  setcomprovanteDefault(row) {

    for (const data of this.listaComprovante) {
      data.selected = false;
    }

    row.selected = true;
    this.comprovanteDefault = row;
  }

  getEfectSelect(row) {

    if (row.selected === true) {
      return '5px solid #F6A113';
    }
    return 'none';

  }

  downloadComprovantes() {

    for (const data of this.listaComprovante) {
      this.createFile(data.file, data.filename);
    }

  }

  createFile(file: any, fileName?: string) {
    let fileNameFormat = fileName;
    fileNameFormat = fileNameFormat.replace('.PNG', '');
    fileNameFormat = fileNameFormat.replace('.png', '');
    fileNameFormat = fileNameFormat.replace('.JPG', '');
    fileNameFormat = fileNameFormat.replace('.jpg', '');
    fileNameFormat = fileNameFormat.replace('.JPEG', '');
    fileNameFormat = fileNameFormat.replace('.jpeg', '');

    let contentType = '';

    if (fileName.match(/.PNG/) || fileName.match(/.png/)) {
      contentType = 'data:image/png;base64,';
      fileNameFormat = fileNameFormat + '.png';
    } else {
      contentType = 'data:image/jpeg;base64,';
      fileNameFormat = fileNameFormat + '.jpeg';
    }

    let dwldLink = document.createElement("a");
    dwldLink.setAttribute("href", contentType + file);
    dwldLink.setAttribute("download", fileNameFormat);
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  dismiss() {
    this.ref.close();
  }

}
